/** Amount of time, in milliseconds, to leave the alert visible to the user. */
const ALERT_DISPLAY_TIMEOUT = 3000

module.exports = {
    ALERT_DISPLAY_TIMEOUT
}